import { sendAnalyticsEvent } from '@devsbb/analytics-client';
import { SegmentWishlistPayloadModel } from './types';

export const trackSegmentWishListEvent = (payload: SegmentWishlistPayloadModel): void => {
    const { eventAction } = payload;

    sendAnalyticsEvent<SegmentWishlistPayloadModel>(eventAction, { ...payload });
};
